import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  NewHeadlineTextAssetRoot: {
    width: '100%'
  },
  LinearProgress: {
    margin: '-8px -16px',
    marginBottom: 4
  },
  TextField: {
    '& .MuiFormHelperText-root': {
      textAlign: 'right'
    },

    '& textarea': {
      paddingRight: 30
    }
  },
  ButtonGroup: {
    marginTop: -15
  },
  Button: {
    padding: 0,
    margin: 0,
    marginRight: '10px'
  },
  VariationScoreContainer: {
    position: 'absolute',
    right: 28,
    top: 18
  }
});
